module.exports = {
  NODE_ENV: "production",
  hostURL: "https://idaas.shopspade.com/",
  workorderWebEntry: "https://workorder.shopspade.com/",
  shopApi: "https://shop.shopspade.com/api",
};
